module.exports = __webpack_public_path__ + "static/media/500px.e3046539.svg";